import { action, computed, reaction } from 'mobx'
import { ViewCategoryViewModel } from '../shared-consumer/viewModels/ViewCategoryViewModel'
import analytics from '../src/stores/analytics'
import RootStore from '../src/stores/RootStore'

export class CategoryViewModel extends ViewCategoryViewModel {
  constructor(store: RootStore) {
    super(store)
  }

  @action.bound async setCategory(categoryName: string) {
    const { router, categoryStore, checkoutStore } = this.store

    this.category = categoryStore.items.find(category => category.urlSafeName === categoryName)

    // Redirect if no category
    if (!this.category) {
      router.push('/categories')
      return
    }

    await this.fetchTreatments()

    // Track
    analytics.page('ViewCategory', {
      categoryName: this.category.data.name,
    })

    // If the customers post code is changed we need to refetch the treatments
    reaction(() => checkoutStore.booking.data.postcodeId, () => {
      this.fetchTreatments()
    })
  }

  @action.bound viewTreatment = (treatmentId: string) => {
    const treatment = this.getTreatmentFromId(treatmentId)
    if (treatment) {
      // For A/B Test: treatmentAvailabilityLabels
      const lowAvailability = treatment.lowAvailability ? 'lowAvailability' : ''
      this.store.modalController.openModal('treatment', treatment.name, lowAvailability)
    }
  }

  @computed get loading() {
    const { treatmentStore, categoryStore } = this.store
    return treatmentStore.loading || categoryStore.loading
  }
}
